import React, { useState, useEffect } from "react";
import styles from "./NotificationManager.module.scss";
import { MdModeEdit, MdRestoreFromTrash } from "react-icons/md";
import { toast } from "react-toastify";
import { db } from "../../firebase";
import AddNotificationModal from "./AddNotificationModal";
import EditNotificationModal from "./EditNotificationModal";
import Header from "../header/header";

export default function NotificationManager() {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [descriptionModalData, setDescriptionModalData] = useState(null);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const response = await db
        .collection("notification-banner")
        .orderBy("createdAt", "desc")
        .get();
      const data = response.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setNotifications(data);
    } catch (error) {
      console.error("Error fetching notifications: ", error);
      toast.error("Error fetching notifications");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteNotification = async (id) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this notification?"
    );
    if (!confirmation) return;
    try {
      await db.collection("notification-banner").doc(id).delete();
      toast.success("Notification deleted successfully");
      fetchNotifications();
    } catch (error) {
      console.error("Error deleting notification: ", error);
      toast.error("Error deleting notification");
    }
  };

  const handleEditNotification = (notification) => {
    setEditModalData(notification);
  };

  if (loading) {
    return <div>Loading...</div>; // Replace with your CustomSpinner if available
  }

  return (
    <div>
    <Header />
    <div className={styles.notificationManager}>
      {/* Header Row */}
      <div className={styles.headerRow}>
        <h4>Notifications</h4>
        <button
          className={styles.addButton}
          onClick={() => setShowAddModal(true)}
        >
          Add Notification
        </button>
      </div>
      <p className={styles.subTitle}>
        Manage notifications by adding, editing, or deleting them.
      </p>
      <hr />

      {/* Notifications Table */}
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Title</th>
              <th>Message</th>
              <th>Target Accounts</th>
              <th>Expires At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {notifications.map((notification) => (
              <tr key={notification.id}>
                <td>{notification.title}</td>
                <td>
                  {notification.message.length > 100 ? (
                    <>
                      {notification.message.slice(0, 100)}...
                      <span
                        className={styles.readMore}
                        onClick={() => setDescriptionModalData(notification)}
                      >
                        Read more
                      </span>
                    </>
                  ) : (
                    notification.message
                  )}
                </td>
                <td>{notification.targetAccounts.join(", ")}</td>
                <td>
                  {notification.expiresAt
                    ? new Date(
                        notification.expiresAt.seconds
                          ? notification.expiresAt.seconds * 1000
                          : notification.expiresAt
                      ).toLocaleDateString()
                    : "--"}
                </td>
                <td className={styles.actionIcons}>
                  <MdModeEdit
                    onClick={() => handleEditNotification(notification)}
                    className={`${styles.icon} ${styles.edit}`}
                    title="Edit Notification"
                  />
                  <MdRestoreFromTrash
                    onClick={() => handleDeleteNotification(notification.id)}
                    className={`${styles.icon} ${styles.delete}`}
                    title="Delete Notification"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add Modal */}
      {showAddModal && (
        <AddNotificationModal
          setOpen={setShowAddModal}
          reloadData={fetchNotifications}
        />
      )}

      {/* Edit Modal */}
      {editModalData && (
        <EditNotificationModal
          data={editModalData}
          setOpen={setEditModalData}
          reloadData={fetchNotifications}
        />
      )}

      {/* Description Modal for full message display */}
      {descriptionModalData && (
        <div className={styles.modalContainer}>
          <div className={styles.modalContent}>
            <h3>{descriptionModalData.title}</h3>
            <p>
              <strong>Message:</strong>
            </p>
            <p style={{ whiteSpace: "pre-wrap" }}>
              {descriptionModalData.message}
            </p>
            <button onClick={() => setDescriptionModalData(null)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
    </div>
  );
}
